import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SafeSend } from '@ucx-js/chat-ui';
import { HttpErrorResponse } from '@angular/common/http';

export const SafeSendActions = createActionGroup({
  source: 'SafeSend',
  events: {
    'Prepare Safe Send': emptyProps(),
    'Get Template Success': props<{ result: any }>(),
    'Get Default Safe Send Template': emptyProps(),
    'Submit Successfully': props<{ value: SafeSend }>(),
    'Submit Failed': emptyProps(),
    'Create Safe Send': props<{ value: SafeSend; messageId?: string }>(),
    'Update Safe Send': props<{ value: SafeSend }>(),
    'Prepare Agent Safe Send': props<{
      safeSendUrl: string;
      messageId: string;
    }>(),
    'Send Safe Send Data': emptyProps(),
    'Create Confirmation Message': emptyProps(),
    'On Get Proactive SS Form Template Error': props<{
      error: HttpErrorResponse;
    }>(),
    'On Send Safe Send Error': props<{ error: HttpErrorResponse }>(),
    'On Get Questionnaire': props<{ error: HttpErrorResponse }>(),
  },
});
